module.exports = __webpack_public_path__ + "static/media/TabletTopOrdersScreen.586f5630.png";